var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.about.title,"cover":_vm.cover,"no-container":""}},[_c('SectionTemplate',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.about.text)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }